import { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { selectCustomStyles } from '../../../../components/common/shared/select.styled';
import PlanActionsRadio from "./PlanActionsRadio/PlanActionsRadio";

const PlanActionsRadioGroup = ({ radiosDisabled, extendDropdownOptions, shortenDropdownOptions, renewDropdownOptions, creditCardsOptions, onChange, onSelectChange }) => {
    const { t } = useTranslation();
    const [currentRadio, setCurrentRadio] = useState('');

    const onRadioChange = e => {
        onChange(e);
        setCurrentRadio(e.target.value)
    };

    const {
        extendDisabled, 
        shortenDisabled, 
        stopAllDisabled, 
        renewDisabled, 
        switchCardDisabled
    } = radiosDisabled;

    return (
        <>
            <PlanActionsRadio
                disabled={extendDisabled}
                value='extend'
                onChange={onRadioChange}
            >
                {t('searchPayments.radioHeaders.extend')}
                <Select 
                    styles={selectCustomStyles}
                    className='dropdown' 
                    options={extendDropdownOptions}
                    isDisabled={extendDisabled || currentRadio !== 'extend'}
                    onChange={e => onSelectChange(e.value, 'extendDropdown')}
                />
            </PlanActionsRadio>
            <PlanActionsRadio
                disabled={shortenDisabled}
                value='shorten'
                onChange={onRadioChange}
            >
                {t('searchPayments.radioHeaders.shorten')}
                <Select 
                    styles={selectCustomStyles}
                    className='dropdown' 
                    options={shortenDropdownOptions} 
                    isDisabled={shortenDisabled || currentRadio !== 'shorten'}
                    onChange={e => onSelectChange(e.value, 'shortenDropdown')}
                />
            </PlanActionsRadio>
            <PlanActionsRadio
                disabled={stopAllDisabled}
                value='stopAll'
                onChange={onRadioChange}
            >
                {t('searchPayments.radioHeaders.stopAll')}
            </PlanActionsRadio>
            <PlanActionsRadio
                disabled={renewDisabled}
                value='renew'
                onChange={onRadioChange}
            >
                {t('searchPayments.radioHeaders.renew')}
                <Select 
                    styles={selectCustomStyles}
                    className='dropdown' 
                    options={renewDropdownOptions} 
                    isDisabled={renewDisabled || currentRadio !== 'renew'}
                    onChange={e => onSelectChange(e.value, 'renewDropdown')}
                />
            </PlanActionsRadio>
            <PlanActionsRadio
                disabled={switchCardDisabled}
                value='switchCreditCard'
                onChange={onRadioChange}
            >
                {t('searchPayments.radioHeaders.switchCard')}
                <Select 
                    styles={selectCustomStyles}
                    className='dropdown' 
                    options={creditCardsOptions}
                    isDisabled={switchCardDisabled || currentRadio !== 'switchCreditCard'}
                    onChange={e => onSelectChange(e.value, 'switchCardDropdown')}
                />
            </PlanActionsRadio>
        </>
    );
};

export default PlanActionsRadioGroup;